// List View Quantity Controls
// Version: 3.7.0 - Added savings percentage badges to grid view pricing


// Cart management variables
let currentCart = { items: [] };
let delegationAttached = false;

// Expose functions globally for inline onclick/onchange (ensures +/- work)
window.updateListQuantity = function(inputId, change) {
  const input = document.getElementById(inputId);
  if (!input) return;
  
  const currentValue = parseInt(input.value) || 0;
  const max = parseInt(input.dataset.max) || 99;
  const newValue = Math.max(0, Math.min(max, currentValue + change));
  
  input.value = newValue;
  updateListAddButton(inputId);
};

window.updateListAddButton = function(inputId) {
  const input = document.getElementById(inputId);
  if (!input) return;
  
  const quantity = parseInt(input.value) || 0;
  const variantContainer = input.closest('[data-variant-container]');
  if (!variantContainer) return;
  
  const addButton = variantContainer.querySelector('.list-add-to-cart');
  if (!addButton) return;
  
  addButton.disabled = quantity === 0;
};

// Internal version for sync
function updateListAddButton(inputId) {
  window.updateListAddButton(inputId);
}

// Refresh cart data
async function refreshCart() {
  try {
    const response = await fetch('/cart.js');
    if (response.ok) {
      currentCart = await response.json();
    }
  } catch (error) {
    console.error('Failed to fetch cart:', error);
  }
}

// Get quantity of variant already in cart
function getQuantityInCart(variantId) {
  const cartItem = currentCart.items.find(item => item.variant_id === variantId || item.id === variantId);
  return cartItem ? cartItem.quantity : 0;
}

// Update cart count bubble in header
function updateCartBubble() {
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (cartIcon) {
    let cartBubble = cartIcon.querySelector('.cart-count-bubble');
    
    if (!cartBubble) {
      cartBubble = document.createElement('div');
      cartBubble.className = 'cart-count-bubble';
      cartBubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"> items</span>';
      cartIcon.appendChild(cartBubble);
    }
    
    const countSpan = cartBubble.querySelector('span[aria-hidden="true"]');
    const visuallyHiddenSpan = cartBubble.querySelector('.visually-hidden');
    if (countSpan) {
      countSpan.textContent = currentCart.item_count;
    }
    if (visuallyHiddenSpan) {
      visuallyHiddenSpan.textContent = `${currentCart.item_count} items`;
    }
    
    cartBubble.classList.remove('hidden');
    cartBubble.style.display = '';
  }
}

// Show message below the add to cart button
function showVariantMessage(variantContainer, message, isError = false) {
  const existingMessage = variantContainer.querySelector('.list-variant-message');
  if (existingMessage) {
    existingMessage.remove();
  }
  
  const messageElement = document.createElement('div');
  messageElement.className = 'list-variant-message';
  messageElement.style.cssText = `
    color: ${isError ? '#d32f2f' : '#4caf50'};
    font-size: 1.2rem;
    padding: 0.8rem;
    margin-top: 0.5rem;
    background: ${isError ? 'rgba(211, 47, 47, 0.1)' : 'rgba(76, 175, 80, 0.1)'};
    border-radius: 0.5rem;
    text-align: center;
    max-width: 150px;
    word-wrap: break-word;
    line-height: 1.4;
  `;
  messageElement.textContent = message;
  
  const addButton = variantContainer.querySelector('.list-add-to-cart');
  if (addButton && addButton.parentNode) {
    addButton.parentNode.insertBefore(messageElement, addButton.nextSibling);
  }
  
  const hideDelay = message.includes('tried to add') ? 8000 : 5000;
  setTimeout(() => {
    if (messageElement && messageElement.parentNode) {
      messageElement.remove();
    }
  }, hideDelay);
}

// Delegated click handler for add to cart buttons
async function handleListAddClick(e) {
  if (!e.target.matches('.list-add-to-cart')) return;
  

  
  const button = e.target;
  if (button.disabled) {
    return;
  }
  
  // Prevent interference (links, other handlers)
  e.preventDefault();
  e.stopPropagation();
  
  const variantId = parseInt(button.dataset.variantId);
  const inputId = button.dataset.quantityInput;
  const maxQuantity = parseInt(button.dataset.maxQuantity) || 99;
  const hasInventoryTracking = button.dataset.hasInventoryTracking === 'true';
  const input = document.getElementById(inputId);
  let quantity = input ? (parseInt(input.value) || 0) : 0;
  

  
  const originalText = button.textContent;
  const quantityInCart = getQuantityInCart(variantId);
  const availableToAdd = maxQuantity - quantityInCart;
  const variantContainer = button.closest('[data-variant-container]');
  
  if (quantity === 0) {

    return;
  }
  
  if (hasInventoryTracking && availableToAdd <= 0) {
    showVariantMessage(variantContainer, `You already have ${quantityInCart} in your cart. No more available.`, true);
    return;
  }
  
  const originalQuantity = quantity;
  if (hasInventoryTracking && quantity > availableToAdd) {
    quantity = availableToAdd;
    if (input) input.value = quantity;
  }
  
  button.disabled = true;
  button.textContent = 'Adding...';
  button.classList.add('adding');
  
  try {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    const response = await fetch('/cart/add.js', { method: 'POST', body: formData });
    const data = await response.json();
    
    if (response.ok) {
      await refreshCart();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      updateCartBubble();
      
      button.textContent = 'Added!';
      button.style.backgroundColor = '#4caf50';
      button.style.color = '#fff';
      
      if (originalQuantity > quantity) {
        showVariantMessage(variantContainer, `Only ${quantity} item${quantity !== 1 ? 's' : ''} added (you tried to add ${originalQuantity}). You now have ${quantityInCart + quantity} in cart.`, true);
      } else {
        showVariantMessage(variantContainer, `Added ${quantity} item${quantity !== 1 ? 's' : ''} to cart!`, false);
      }
      
      setTimeout(() => {
        button.textContent = originalText;
        button.style.backgroundColor = '';
        button.style.color = '';
        button.disabled = false;
        button.classList.remove('adding');
      }, 2000);
    } else {
      throw new Error(data.description || data.message || 'Failed to add to cart');
    }
  } catch (error) {
    console.error('Add to cart error:', error);
    if (variantContainer) {
      showVariantMessage(variantContainer, `Error: ${error.message}`, true);
    }
    button.textContent = originalText;
    button.disabled = false;
    button.classList.remove('adding');
  }
}

// Sync all button states post-reload (ensures disabled if quantity=0)
function syncButtonStates() {

  document.querySelectorAll('.list-quantity-input').forEach(input => {
    window.updateListAddButton(input.id);
  });
}

// Setup delegation once
function setupDelegation() {
  if (delegationAttached) return;
  
  document.addEventListener('click', handleListAddClick, true); // Capture phase for early intercept
  delegationAttached = true;
  
}

// Initialize cart on page load
refreshCart();

document.addEventListener('DOMContentLoaded', () => {
  
  setupDelegation();
  syncButtonStates();
});

// Re-sync after Shopify section reloads (filters, pagination)
document.addEventListener('shopify:section:load', () => {
  
  setTimeout(syncButtonStates, 100); // Slight delay for DOM settle
});

// Re-sync after facets render complete
document.addEventListener('facets:render:complete', () => {
  
  setTimeout(syncButtonStates, 100);
});

// Re-sync on view refresh
document.addEventListener('list-view:refreshed', () => {
  
  setTimeout(syncButtonStates, 100);
});

// Add savings percentage badges to grid view
function addGridViewSavingsBadges() {
  document.querySelectorAll('.grid-view-card .price__sale').forEach(saleContainer => {
    // Skip if badge already exists
    if (saleContainer.querySelector('.price-savings-badge')) return;
    
    // Get regular and sale prices
    const regularPriceElement = saleContainer.querySelector('.price-item--regular');
    const salePriceElement = saleContainer.querySelector('.price-item--sale');
    
    if (!regularPriceElement || !salePriceElement) return;
    
    // Extract numeric values (remove currency symbols and text)
    const regularPriceText = regularPriceElement.textContent.trim();
    const salePriceText = salePriceElement.textContent.trim();
    
    // Parse prices - handle various formats like "$25.49 CAD" or "$25.49"
    const regularPrice = parseFloat(regularPriceText.replace(/[^0-9.]/g, ''));
    const salePrice = parseFloat(salePriceText.replace(/[^0-9.]/g, ''));
    
    if (isNaN(regularPrice) || isNaN(salePrice) || regularPrice <= salePrice) return;
    
    // Calculate savings percentage
    const savings = regularPrice - salePrice;
    const savingsPercent = Math.round((savings / regularPrice) * 100);
    
    // Create and insert savings badge
    const badge = document.createElement('span');
    badge.className = 'price-savings-badge';
    badge.textContent = `${savingsPercent}% off`;
    
    // Insert after the sale price
    salePriceElement.parentNode.appendChild(badge);
  });
}

// Initialize grid view savings badges on load
document.addEventListener('DOMContentLoaded', () => {
  addGridViewSavingsBadges();
});

// Re-add badges after section reloads
document.addEventListener('shopify:section:load', () => {
  setTimeout(addGridViewSavingsBadges, 100);
});

// Re-add badges after facets render
document.addEventListener('facets:render:complete', () => {
  setTimeout(addGridViewSavingsBadges, 100);
});